import * as React from "react";

import {ListEditorItemPanel} from "../../molecules/list-editor-item-panel/list-editor-item-panel";
import {TagItem} from "../tag-cache/tag-cache";
import {TagSelector} from "../tag-selector/tag-selector";

export interface ITagListEditorItemProps {
    isPrimary: boolean;
    value: string | null;
    placeholder?: string;
    onChange: (value: TagItem | null) => void;
    onRemove: () => void;
    mediaId: string;
    availableTags: TagItem[];
}

export class TagListEditorItem extends React.Component<ITagListEditorItemProps> {
    public constructor(props: ITagListEditorItemProps) {
        super(props);
        this.state = {
            isEditing: !props.value,
        };
    }

    public render() {
        const handleChange = (value: TagItem | null) => {
            this.props.onChange(value);
        };

        return (
            <ListEditorItemPanel onRemove={this.props.value ? this.props.onRemove : undefined}>
                <TagSelector
                    mediaId={this.props.mediaId}
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    onChange={handleChange}
                    isBold={this.props.isPrimary}
                    availableTags={this.props.availableTags}
                />
            </ListEditorItemPanel>
        );
    }
}
